// Default Terms & Conditions body printed at the bottom of every quotation
// PDF when no operator-supplied override exists in `app_settings`. Kept here
// so the Settings page (where the user edits the value) and the print
// renderer (where it is finally substituted and shown) can share one
// canonical string.
export const DEFAULT_QUOTATION_TERMS = [
  "1. This quotation is valid for 30 days from the date of issue.",
  "2. Prices are quoted in Ghana Cedis (GH\u20B5) and inclusive of applicable taxes as itemised above.",
  "3. Payment terms: 50% deposit on order confirmation, balance on delivery, unless otherwise agreed in writing.",
  "4. Delivery timelines commence after receipt of deposit and remain subject to material availability.",
  "5. Goods remain the property of {company.name} until full payment is received.",
  "6. Any variations to the agreed scope must be authorised in writing and may incur additional cost.",
].join("\n");

// Resolves the {company.name} token (and any future tokens) in a stored T&C
// blob right before it lands on the PDF. We do the substitution at render
// time — not on save — so renaming the company retroactively flows through
// every existing quotation without having to rewrite the stored text.
export function renderQuotationTerms(
  raw: string | null | undefined,
  companyName: string | null | undefined,
): string {
  const body = (raw ?? "").trim().length
    ? String(raw)
    : DEFAULT_QUOTATION_TERMS;
  const safeName = (companyName ?? "").trim() || "BillForge";
  return body.replace(/\{company\.name\}/g, safeName);
}
